import styled from 'styled-components';

export const PropertyExpenseListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
